module.exports = __webpack_public_path__ + "img/courseOutcome.7bfb70b6.png";